module.exports = __webpack_public_path__ + "static/media/compare.2b211845.svg";